module.exports = __webpack_public_path__ + "static/img/yytx15.dd39a80.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx15.png
// module id = 887
// module chunks = 0